<div class="dates-filter-container">
  <div class="dates-filter-header">
    <i class="fa fa-calendar header-icon"></i>
    <span class="header-title">{{ title }}</span>
    <button type="button" class="header-close" (click)="onClose()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="dates-filter-body">
    <!-- Specific date / interval switch -->
    <div class="mode-switch">
      <button
        type="button"
        class="mode-option"
        [class.active]="app.datesFilter.model.dateMode === 'specific'"
        (click)="setDateMode('specific')"
        >
        {{ app.text.manufacturer.specificDate }}
      </button>
      <button
        type="button"
        class="mode-option"
        [class.active]="app.datesFilter.model.dateMode === 'interval'"
        (click)="setDateMode('interval')"
        >
        {{ app.text.manufacturer.dateInterval }}
      </button>
    </div>

    <!-- Specific date -->
    @if (app.datesFilter.model.dateMode === 'specific') {
      <div class="date-field">
        <label class="date-label">{{ app.text.manufacturer.specificDate }}</label>
        <div class="date-input">
          <input
            [(ngModel)]="app.datesFilter.model.specificDate"
            name="specificDate"
            ngbDatepicker
            #specificDate="ngbDatepicker"
            placeholder="YYYY-MM-DD"
            />
          <button class="date-toggle" type="button" (click)="specificDate.toggle()">
            <i class="fa fa-calendar"></i>
          </button>
        </div>
      </div>
    }

    <!-- Date interval -->
    @if (app.datesFilter.model.dateMode === 'interval') {
      <div>
        <div class="date-field">
          <label class="date-label">{{ fromLabel }}</label>
          <div class="date-input">
            <input
              [(ngModel)]="app.datesFilter.model.fromDate"
              name="fromDate"
              ngbDatepicker
              #fromDate="ngbDatepicker"
              placeholder="YYYY-MM-DD"
              />
            <button class="date-toggle" type="button" (click)="fromDate.toggle()">
              <i class="fa fa-calendar"></i>
            </button>
          </div>
        </div>
        <div class="date-field">
          <label class="date-label">{{ toLabel }}</label>
          <div class="date-input">
            <input
              [(ngModel)]="app.datesFilter.model.toDate"
              name="toDate"
              ngbDatepicker
              #toDate="ngbDatepicker"
              placeholder="YYYY-MM-DD"
              />
            <button class="date-toggle" type="button" (click)="toDate.toggle()">
              <i class="fa fa-calendar"></i>
            </button>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="dates-filter-footer">
    <button class="btn apply-btn" type="button" (click)="onApply()">
      {{ app.text.app.apply }}
    </button>
  </div>
</div>
